"use strict";
/**
 * Types for the "did you mean this property?" prompt on the PII page.
 *
 * When the applicant's name does not match any name on the title of the property they typed, the
 * application would eventually be found ineligible for home ownership. Before letting them move on,
 * we search the property records for properties in the same zip owned by someone with their name and
 * offer those as alternatives.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyAddressSuggestionChoice = exports.OwnerNameAttestationOutcome = exports.OwnerNameAttestation = void 0;
/** @TranslateToPython @TranslateToEnum */
var OwnerNameAttestation;
(function (OwnerNameAttestation) {
    OwnerNameAttestation["applicantIsOwner"] = "applicantIsOwner";
    OwnerNameAttestation["spouseOrFamilyMember"] = "spouseOrFamilyMember";
    OwnerNameAttestation["recentlyPurchased"] = "recentlyPurchased";
    OwnerNameAttestation["rentsProperty"] = "rentsProperty";
    OwnerNameAttestation["doesNotKnowOwner"] = "doesNotKnowOwner";
})(OwnerNameAttestation || (exports.OwnerNameAttestation = OwnerNameAttestation = {}));
var OwnerNameAttestationOutcome;
(function (OwnerNameAttestationOutcome) {
    OwnerNameAttestationOutcome["continue"] = "continue";
    OwnerNameAttestationOutcome["addCoApplicant"] = "addCoApplicant";
    OwnerNameAttestationOutcome["loanNotApproved"] = "loanNotApproved";
    OwnerNameAttestationOutcome["review"] = "review";
})(OwnerNameAttestationOutcome || (exports.OwnerNameAttestationOutcome = OwnerNameAttestationOutcome = {}));
/** @TranslateToPython @TranslateToEnum */
var PropertyAddressSuggestionChoice;
(function (PropertyAddressSuggestionChoice) {
    // Replaced the property address with one of the suggestions.
    PropertyAddressSuggestionChoice["replacedWithSuggestion"] = "replacedWithSuggestion";
    // Explicitly moved forward with the address they typed.
    PropertyAddressSuggestionChoice["keptEnteredAddress"] = "keptEnteredAddress";
})(PropertyAddressSuggestionChoice || (exports.PropertyAddressSuggestionChoice = PropertyAddressSuggestionChoice = {}));
